module.exports = __webpack_public_path__ + "f52668ee.png";